import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import AdminLogin from './components/AdminLogin';
import Home from './components/Home';
import ModelDeployment from './components/ManageModel';
import ExportedModels from './components/ExportedModels';
import BatchInferenceHistory from './components/BatchInferenceHistory';
import PredictionAuditTrail from './components/PredictionAuditTrail';
import ManageRoute from './components/ManageRoute'
import ApiManagement from './components/ManageApiKey';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import UpdatePassword from './components/UpdatePassword';
import ModelRoutingConfig from './components/ModelRoutingConfig'
import ManagePipeline from './components/ManagePipeline'
import DriftReportManagement from './components/DriftReportManagement'
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css"

const App = () => {
    const [token, setToken] = useState(localStorage.getItem('adminToken') || null);
    const [sessionWarning, setSessionWarning] = useState(false);

    useEffect(() => {
        if (!token) {
            setSessionWarning(false);
            return;
        }

        const checkTokenExpiry = () => {
            try {
                const { exp } = jwtDecode(token);
                const secsLeft = exp - Math.floor(Date.now() / 1000);
                if (secsLeft <= 0) {
                    ['adminToken', 'adminId', 'adminUsername', 'adminRoles'].forEach(k => localStorage.removeItem(k));
                    setToken(null);
                    setSessionWarning(false);
                } else {
                    setSessionWarning(secsLeft <= 1200); // warn if ≤20 min
                }
            } catch {
                setSessionWarning(false);
            }
        };

        checkTokenExpiry();
        const id = setInterval(checkTokenExpiry, 60_000);
        return () => clearInterval(id);
    }, [token]);

    return (
        <Router>
            {sessionWarning && (
                <div className="session-expiry-banner">
                    ⚠️ Your session expires in less than 20 minutes. Please save your work and sign in again.
                    <button onClick={() => setSessionWarning(false)}>Dismiss</button>
                </div>
            )}
            <Header />
            <Sidebar />
            <Routes>
                <Route path="/home" element={token ? <Home /> : <AdminLogin setToken={setToken} />} />
                <Route path="/manage-pipeline" element={token ? <ManagePipeline /> : <AdminLogin setToken={setToken} />} />
                <Route path="/manage-route" element={token ? <ManageRoute /> : <AdminLogin setToken={setToken} />} />
                <Route path="/manage-model" element={token ? <ModelDeployment /> : <AdminLogin setToken={setToken} />} />
                <Route path="/exported-models" element={token ? <ExportedModels /> : <AdminLogin setToken={setToken} />} />
                <Route path="/batch-inference-history" element={token ? <BatchInferenceHistory /> : <AdminLogin setToken={setToken} />} />
                <Route path="/audit-trail" element={token ? <PredictionAuditTrail /> : <AdminLogin setToken={setToken} />} />
                <Route path="/drift-report" element={token ? <DriftReportManagement /> : <AdminLogin setToken={setToken} />} />
                <Route path="/api-keys" element={token ? <ApiManagement /> : <AdminLogin setToken={setToken} />} />
                <Route path="/model-config" element={token ? <ModelRoutingConfig /> : <AdminLogin setToken={setToken} />} />
                <Route path="/change-password" element={token ? <UpdatePassword /> : <AdminLogin setToken={setToken} />} />
                <Route path="/" element={<AdminLogin setToken={setToken} />} />
            </Routes>
        </Router>
    );
};

export default App;
